
export const SET_COUNTRIES_RULES = `SET_COUNTRIES_RULES`;